import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class BaselineValue extends BasicEntity {
bid: number | null;
ch: BaselineValue[];
chron: string;
cr: number | null;
cv: string;
f: string;
key: string;
level: number | null;
m: string;
mkey: string;
scen: string;
v: string;
valor: string;
vs: string;
vsp: string;
weight: number | null;
}

